var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"2","width":"20","height":"20","rx":"5","ry":"5","key":0}),React.createElement("path",{"d":"M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01","key":1})]);
}

Instagram.defaultProps = {"width":"24","height":"24","fill":"none","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-instagram"};

module.exports = Instagram;

Instagram.default = Instagram;
